import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'utils/translation';
import { Button, CardActions, Typography } from '@material-ui/core';
import { Dir } from '../../../../../modules/dirs';
import DirectoryPicker, {
  DirView
} from '../../../../../modules/dirs/components/DirectoryPicker';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  divider: {
    height: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end',
    paddingRight: 0
  }
}));

interface MoveFormProps {
  onCancel: () => void;
  onSubmit: (dirId: number) => void;
  title: string;
  filter?(dir: DirView): boolean;
}

export const MoveForm: React.FC<MoveFormProps> = ({
  onCancel,
  onSubmit,
  title,
  filter
}) => {
  const classes = useStyles();
  const { t } = useTranslation('myDisk');
  const [dir, setDir] = React.useState<Nullable<Dir>>(null);

  const handleSubmit = () => {
    if (dir) {
      onSubmit(dir.id);
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className={classes.root}>
      <Typography align="center" gutterBottom variant="h3">
        {title}
      </Typography>
      <DirectoryPicker value={dir} onChange={setDir} filter={filter} />
      <div className={classes.divider} />
      <CardActions className={classes.actions}>
        <Button variant="contained" onClick={handleCancel}>
          {t('Cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={!dir}
          type="submit"
          color="primary"
          onClick={handleSubmit}>
          {t('Move')}
        </Button>
      </CardActions>
    </div>
  );
};
